import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import {
  makeSaleMngCostData,
  makeSalesMngCostHeader,
} from '../../utils/sales_mng_cost_stats';
import * as salesCostsApi from '../../lib/api/salesCosts';
import SalesMngCostStatsTable from '../../components/sales_mng_cost_stats/SalesMngCostStatsTable';

//----------------------------------------------------------------------
const SalesMngCostStatsHqContainer = ({ selectedYear, tableRef }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  useEffect(() => {
    // 2026-10-20 화면 점검: useEffect 콜백 자체가 async 함수였다 - async 함수는 항상 Promise를
    // 반환하는데, React는 effect가 반환한 값을 "클린업 함수"로 여기고 언마운트/재실행 시 그걸
    // 호출한다. Promise는 함수가 아니라서 그 시점에 "TypeError: ... is not a function"으로
    // 터진다 - 이 화면(판매관리비 통계 기본 탭)을 보고 다른 화면으로 넘어갈 때(클라이언트 사이드
    // 라우팅으로 언마운트될 때)만 터지고 새로고침/직접 진입은 멀쩡했던 이유. async 로직을 안쪽
    // 함수로 분리해서 effect 콜백 자체는 동기 함수로 유지.
    if (!selectedYear) {
      return;
    }

    let active = true;

    (async () => {
      setLoading(true);

      const headers = makeSalesMngCostHeader();
      setHeaderRows(headers);

      try {
        const res = await salesCostsApi.getSalesCostsStaticTotal(selectedYear);
        if (active && res.data.list) {
          setData(res.data.list);
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      if (active) {
        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [selectedYear]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <SalesMngCostStatsTable
          data={data}
          loading={loading}
          headerRows={headerRows}
          tableRef={tableRef}
        />
      )}
    </Box>
  );
};
//----------------------------------------------------------------------
export default SalesMngCostStatsHqContainer;
